<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm">
      <div class="modal-content">
        <div class="modal-dialog-scrollable-general">
          <div class="modal-header">
            <div class="header-title">
              <div class="d-flex flex-column">
                <h4 class="title-modal">{{ isResend ? 'Reenviar' : 'Enviar' }} contrato de câmbio</h4>
           
                <p class="p-text-grey-scale-dark mg-bottom-24">
                  Para confirmação do envio, adicione o número e o contrato de câmbio.
                </p>
              </div>
            </div>
            <div (click)="closeModal()" class="close-icon tappable">
              <img src="assets/image/close-modal-icon.svg" />
            </div>
          </div>

          <div class="modal-body-content">
            <div *ngIf="boobleModalData?.remmitanceType == 'OUTBOUND'" [formGroup]="formSettlement" class="padding-16">
              <div class="row header-name titles border-grey-light d-flex justify-content-between">
                <ng-container *ngIf="
                    formSettlement.get('contractSettlementNumber')?.invalid
                  ">
                  <div class="row gap-10 title-company">
                    <img alt="" src="assets/image/1-icon.svg" />
                    <h6 class="mg-top-10">Número do contrato de câmbio</h6>
                  </div>
                  <img alt="" src="assets/image/loading-icon.svg" />
                </ng-container>

                <ng-container *ngIf="formSettlement.get('contractSettlementNumber')?.valid">
                  <div class="row gap-10 title-company">
                    <img alt="" src="assets/image/1-icon-green.svg" />
                    <h6 class="mg-top-10">Número do contrato de câmbio</h6>
                  </div>
                  <img alt="" src="assets/image/check-green.svg" />
                </ng-container>
              </div>

              <div class="row input-document-1">
                <mat-form-field appearance="outline">
                  <mat-label>Nº do contrato de câmbio </mat-label>
                  <input matInput formControlName="contractSettlementNumber" type="text" class="" name="name" />
                  <mat-error class="text-danger" *ngIf="
                      formSettlement.controls['contractSettlementNumber']
                        .touched &&
                      formSettlement.controls['contractSettlementNumber'].errors
                        ?.required
                    ">
                    Número do contrato obrigatório</mat-error>

                  <mat-error class="text-danger" *ngIf="
                      formSettlement.controls['contractSettlementNumber']
                        .touched &&
                      formSettlement.controls['contractSettlementNumber'].errors
                        ?.pattern
                    ">
                    Número do contrato inválido</mat-error>
                </mat-form-field>
              </div>

              <div class="row header-name titles border-grey-light d-flex justify-content-between">
                <ng-container *ngIf="
                    (boobleModalData?.statusFlow == 'AVAILABLE_PAYMENT' || boobleModalData?.statusFlow == 'IDENTIFYING_PAYMENT')
                      ? !formSettlement.get('exchangeContractFile')?.value
                      : (!formSettlement.get('exchangeContractFile')?.value ||
                        (!formSettlement.get('proofOperationFile')?.value &&
                          !formSettlement.get('proofOperationLater')?.value) ||
                        (!formSettlement.get('exchangeContractFile')?.value &&
                          formSettlement.get('proofOperationLater')?.value))
                  ">
                  <div class="row gap-10 title-company">
                    <img alt="" src="assets/image/2-icon.svg" />
                    <h6 class="mg-top-10">Documentos da empresa</h6>
                  </div>
                  <img alt="" src="assets/image/loading-icon.svg" />
                </ng-container>

                <ng-container *ngIf="
                    (boobleModalData?.statusFlow == 'AVAILABLE_PAYMENT' || boobleModalData?.statusFlow == 'IDENTIFYING_PAYMENT')
                      ? formSettlement.get('exchangeContractFile')?.value
                      : ((formSettlement.get('exchangeContractFile')?.value &&
                          formSettlement.get('proofOperationFile')?.value) ||
                        (formSettlement.get('exchangeContractFile')?.value &&
                          formSettlement.get('proofOperationLater')?.value))
                  ">
                  <div class="row gap-10 title-company">
                    <img alt="" src="assets/image/2-icon-green.svg" />
                    <h6 class="mg-top-10">Documentos da empresa</h6>
                  </div>
                  <img alt="" src="assets/image/check-green.svg" />
                </ng-container>
              </div>

              <div>
                <ng-container *ngIf="!formSettlement.get('exchangeContractFile')?.value">
                  <input #documentFile type="file" id="exchangeContractFile" style="display: none"
                    (input)="exchangeContractFileChange(formSettlement, $event)" />
                  <div class="row d-flex row-no-file justify-content-between" (click)="documentFile.click()">
                    <div class="file-no-anexado">
                      <img alt="" src="assets/image/document-add-icon.svg" />
                      <p class="align-self-center title">Contrato de câmbio</p>
                      <p class="format-text">
                        Formatos aceitos .pdf .doc .png e .jpg
                      </p>
                    </div>

                    <div class="file-anexar border-grey-light">
                      <p class="p-text-grey align-self-center">
                        <strong class="pointer">Anexar</strong>
                      </p>
                    </div>
                  </div>
                </ng-container>

                <div *ngIf="formSettlement.get('exchangeContractFile')?.value"
                  class="row d-flex row-file justify-content-between">
                  <div class="file-anexado">
                    <div class="img-delete">
                      <img alt="" src="assets/image/document-icon.svg" />
                    </div>
                    <p class="p-text-grey align-self-center">
                      {{ getFileName(formSettlement.get("exchangeContractFile")?.value) }}
                    </p>
                  </div>

                  <div (click)="resetControl('exchangeContractFile')" class="file-removed border-grey-light">
                    <p class="text-danger align-self-center">
                      <strong>Remover documento</strong>
                    </p>
                  </div>
                </div>
              </div>

              <div *ngIf="!formSettlement.get('proofOperationLater')?.value && !(boobleModalData?.statusFlow == 'AVAILABLE_PAYMENT' || boobleModalData?.statusFlow == 'IDENTIFYING_PAYMENT')">
                <ng-container *ngIf="!formSettlement.get('proofOperationFile')?.value">
                  <input #proofFile type="file" id="proofOperationFile" style="display: none"
                    (input)="proofOperationFileChange(formSettlement, $event)" />
                  <div class="row d-flex row-no-file justify-content-between" (click)="proofFile.click()">
                    <div class="file-no-anexado">
                      <img alt="" src="assets/image/document-add-icon.svg" />
                      <p class="align-self-center title">
                        Comprovante da operação
                      </p>
                      <p class="format-text">
                        Formatos aceitos .pdf .doc .png e .jpg
                      </p>
                    </div>

                    <div class="file-anexar border-grey-light">
                      <p class="p-text-grey align-self-center">
                        <strong class="pointer">Anexar</strong>
                      </p>
                    </div>
                  </div>
                </ng-container>

                <div *ngIf="formSettlement.get('proofOperationFile')?.value"
                  class="row d-flex row-file justify-content-between">
                  <div class="file-anexado">
                    <div class="img-delete">
                      <img alt="" src="assets/image/document-icon.svg" />
                    </div>
                    <p class="p-text-grey align-self-center">
                      {{ getFileName(formSettlement.get("proofOperationFile")?.value) }}
                    </p>
                  </div>

                  <div (click)="resetControl('proofOperationFile')" class="file-removed border-grey-light">
                    <p class="text-danger align-self-center">
                      <strong>Remover documento</strong>
                    </p>
                  </div>
                </div>
              </div>

              <div class="mb-xl-0 mb-2 toggle">
                <div class="label">&nbsp;</div>
                <mat-slide-toggle formControlName="sendEmail" color="primary">
                  <label class="square mb-0">Enviar e-mail de confirmação para o cliente.
                  </label>
                </mat-slide-toggle>
              </div>

              <div *ngIf="formSettlement.get('proofOperationFile')?.value == null && !(boobleModalData?.statusFlow == 'AVAILABLE_PAYMENT' || boobleModalData?.statusFlow == 'IDENTIFYING_PAYMENT')" class="mb-xl-0 mb-2 toggle">
                <div>
                  <div class="label">&nbsp;</div>
                  <mat-slide-toggle formControlName="proofOperationLater" (change)="resetControl('proofOperationFile')"
                    color="primary">
                    <label class="square mb-0">Anexar o comprovante da operação posteriormente.
                    </label>
                  </mat-slide-toggle>
                </div>

                <div class="alert">
                  <span>
                    Você tem a flexibilidade de anexar o comprovante da operação
                    em um momento posterior à liquidação da ordem. Essa ação
                    pode ser realizada acessando o histórico de todas as ordens
                    na plataforma.
                  </span>
                </div>
              </div>
            </div>

            <div *ngIf="boobleModalData?.remmitanceType == 'INBOUND'" [formGroup]="formSettlementInbound"
              class="padding-16">
              <div class="row header-name titles border-grey-light d-flex justify-content-between">
                <ng-container *ngIf="
                    formSettlementInbound.get('contractSettlementNumber')
                      ?.invalid
                  ">
                  <div class="row gap-10 title-company">
                    <img alt="" src="assets/image/1-icon.svg" />
                    <h6 class="mg-top-10">Número do contrato de câmbio</h6>
                  </div>
                  <img alt="" src="assets/image/loading-icon.svg" />
                </ng-container>

                <ng-container *ngIf="
                    formSettlementInbound.get('contractSettlementNumber')?.valid
                  ">
                  <div class="row gap-10 title-company">
                    <img alt="" src="assets/image/1-icon-green.svg" />
                    <h6 class="mg-top-10">Número do contrato de câmbio</h6>
                  </div>
                  <img alt="" src="assets/image/check-green.svg" />
                </ng-container>
              </div>

              <div class="row input-document-1">
                <mat-form-field appearance="outline">
                  <mat-label>Nº do contrato de câmbio </mat-label>
                  <input matInput formControlName="contractSettlementNumber" type="text" class=""
                    name="contractSettlementNumber" />
                  <mat-error class="text-danger" *ngIf="
                      formSettlementInbound.controls['contractSettlementNumber']
                        .touched &&
                      formSettlementInbound.controls['contractSettlementNumber']
                        .errors?.required
                    ">
                    Número do contrato obrigatório</mat-error>
                  <mat-error class="text-danger" *ngIf="
                      formSettlementInbound.controls['contractSettlementNumber']
                        .touched &&
                      formSettlementInbound.controls['contractSettlementNumber']
                        .errors?.pattern
                    ">
                    Número do contrato inválido</mat-error>
                </mat-form-field>
              </div>

              <div class="row header-name titles border-grey-light d-flex justify-content-between">
                <ng-container *ngIf="
                    !formSettlementInbound.get('exchangeContractFile')?.value
                  ">
                  <div class="row gap-10 title-company">
                    <img alt="" src="assets/image/2-icon.svg" />
                    <h6 class="mg-top-10">Documentos da empresa</h6>
                  </div>
                  <img alt="" src="assets/image/loading-icon.svg" />
                </ng-container>

                <ng-container *ngIf="
                    formSettlementInbound.get('exchangeContractFile')?.value
                  ">
                  <div class="row gap-10 title-company">
                    <img alt="" src="assets/image/2-icon-green.svg" />
                    <h6 class="mg-top-10">Documentos da empresa</h6>
                  </div>
                  <img alt="" src="assets/image/check-green.svg" />
                </ng-container>
              </div>

              <div>
                <ng-container *ngIf="
                    !formSettlementInbound.get('exchangeContractFile')?.value
                  ">
                  <input #documentFileInbound type="file" id="documentFileInbound" style="display: none" (input)="
                      exchangeContractFileChange(formSettlementInbound, $event)
                    " />
                  <div class="row d-flex row-no-file justify-content-between" (click)="documentFileInbound.click()">
                    <div class="file-no-anexado">
                      <img alt="" src="assets/image/document-add-icon.svg" />
                      <p class="align-self-center title">Contrato de câmbio</p>
                      <p class="format-text">
                        Formatos aceitos .pdf .doc .png e .jpg
                      </p>
                    </div>

                    <div class="file-anexar border-grey-light">
                      <p class="p-text-grey align-self-center">
                        <strong class="pointer">Anexar</strong>
                      </p>
                    </div>
                  </div>
                </ng-container>

                <div *ngIf="
                    formSettlementInbound.get('exchangeContractFile')?.value
                  " class="row d-flex row-file justify-content-between">
                  <div class="file-anexado">
                    <div class="img-delete">
                      <img alt="" src="assets/image/document-icon.svg" />
                    </div>
                    <p class="p-text-grey align-self-center">
                      {{ getFileName(formSettlementInbound.get("exchangeContractFile")?.value) }}
                    </p>
                  </div>

                  <div (click)="resetExchangeContractFile()" class="file-removed border-grey-light">
                    <p class="text-danger align-self-center">
                      <strong>Remover documento</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer-new" [style.justify-content]="'space-between'">
          <button type="button" [style.width]="'219px'" [style.heigth]="'48px'" class="btn-outline-dark btn"
            (click)="closeModal()" type="button">
          Cancelar
          </button>

          <button type="button" class="btn-footer btn btn-dark-primary-blue" type="button" (click)="settlementConfirm()"
            [disabled]="
              boobleModalData.remmitanceType == 'INBOUND'
                ? formSettlementInbound.invalid || loading
                : formSettlement.invalid || loading
            ">
            Enviar
            <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>